import { pitchToStaffIndex, pitchToY, staffIndexToY } from "./pitchMath.js";

// Shared by painting and collision detection: only lines actually drawn
// count as obstacles. Coordinates are relative to the notehead origin.
export function ledgerLineGeometry(pitch, clef, symbol = "whole_note") {
  const metrics = {
    whole_note: { width: 20, offsetX: -1.5 },
    half_note: { width: 16.5, offsetX: -3 },
    quarter_note: { width: 17.5, offsetX: -3 }
  };
  const { width, offsetX } = metrics[symbol] || metrics.quarter_note;
  const index = pitchToStaffIndex(pitch, clef);
  const y = pitchToY(pitch, clef);
  const result = [];
  for (let line = -2; line >= index; line -= 2) {
    result.push({ x1: offsetX - 4, x2: offsetX + width + 4, y: staffIndexToY(line) - y });
  }
  for (let line = 10; line <= index; line += 2) {
    result.push({ x1: offsetX - 4, x2: offsetX + width + 4, y: staffIndexToY(line) - y });
  }
  return result;
}
